"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlRadioGroup", function ($timeout, uiUtils, keyCodes) {
  var FOCUSED_CLASS = "tl-focused";
  return {
    restrict: 'E',
    require: ['tlRadioGroup', '?ngModel'],
    transclude: true,
    replace: true,
    template: '<div class="tl-radio-group" ng-transclude></div>',
    link: {
      pre: function linkRadioGroup($scope, $el, $attr, controllers) {
        $el.attr({
          role: "radiogroup",
          tabindex: $el.attr("tabindex") || "0"
        });
        var rgCtrl = controllers[0],
          ngModelCtrl = controllers[1] || uiUtils.fakeNgModel();
        rgCtrl.init(ngModelCtrl);
      }
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        modelCtrl = null;
      ctrl._radioButtonRenderFns = [];
      ctrl.init = function (ngModelCtrl) {
        modelCtrl = ngModelCtrl;
        modelCtrl.$render = ctrl.render;
        bindEvents();
      };
      ctrl.add = function (rbRender) {
        ctrl._radioButtonRenderFns.push(rbRender);
      };
      ctrl.remove = function (rbRender) {
        var index = _.indexOf(ctrl._radioButtonRenderFns, rbRender);
        if (index !== -1) {
          ctrl._radioButtonRenderFns.splice(index, 1);
        }
      };
      ctrl.render = function () {
        for (var i = 0; i < ctrl._radioButtonRenderFns.length; i++) {
          ctrl._radioButtonRenderFns[i]();
        }
      };
      ctrl.setViewValue = function (value, eventType) {
        modelCtrl.$setViewValue(value, eventType);
        ctrl.render();
      };
      ctrl.getViewValue = function () {
        return modelCtrl.$viewValue;
      };
      ctrl.selectNext = function () {
        return changeSelectedButton(1);
      };
      ctrl.selectPrevious = function () {
        return changeSelectedButton(-1);
      };

      /**
       * Change the radio group's selected button by a given increment.
       * If no button is selected, select the first button.
       */
      function changeSelectedButton(increment) {
        var buttons = $element.find('.tl-radio-button');
        var nbButtons = buttons.length;
        if (nbButtons > 0) {
          // TODO : skip disabled radio buttons
          var selected = buttons.filter('.tl-checked');
          var index = buttons.index(selected);
          var nextIndex = index + increment;
          if (nextIndex < 0) {
            nextIndex = nbButtons - 1;
          } else if (nextIndex >= nbButtons) {
            nextIndex = 0;
          }
          var target = buttons.eq(nextIndex);
          target.trigger("click");
        }
      }
      function bindEvents() {
        $scope.mouseActive = false;
        $element.on('keydown', keydownListener).on('mousedown', function (event) {
          $scope.mouseActive = true;
          $timeout(function () {
            $scope.mouseActive = false;
          }, 100);
        }).on('focus', function () {
          if ($scope.mouseActive === false) {
            $element.addClass(FOCUSED_CLASS);
          }
        }).on('blur', function () {
          $element.removeClass(FOCUSED_CLASS);
        });
      }
      function setFocus() {
        if (!$element.hasClass(FOCUSED_CLASS)) {
          $element.addClass(FOCUSED_CLASS);
        }
      }
      function keydownListener(ev) {
        var keyCode = ev.which || ev.keyCode;
        switch (keyCode) {
          case keyCodes.LEFT:
          case keyCodes.UP:
            ev.preventDefault();
            ctrl.selectPrevious();
            setFocus();
            break;
          case keyCodes.RIGHT:
          case keyCodes.DOWN:
            ev.preventDefault();
            ctrl.selectNext();
            setFocus();
            break;
          case keyCodes.ENTER:
            var form = $element.closest("form");
            if (form.length > 0) {
              form.triggerHandler('submit');
            }
            break;
        }
      }
    }
  };
});
ngModule.directive("tlRadioButton", function () {
  var CHECKED_CSS = 'tl-checked';
  return {
    restrict: 'E',
    require: '^tlRadioGroup',
    transclude: true,
    replace: true,
    template: '' + '<div class="tl-radio-button">' + '   <div class="tl-radio-container">' + '       <div class="tl-radio-off"></div>' + '       <div class="tl-radio-on"></div>' + '   </div>' + '   <div ng-transclude class="tl-radio-label"></div>' + '</div>',
    link: function link($scope, $el, $attr, rgCtrl) {
      var lastChecked;

      // TODO : handle both [^tlRadioGroup] , [ngModel] and [ngChecked] approaches (look at tl-checkbox)

      initialize();
      function initialize() {
        rgCtrl.add(render);
        $attr.$observe('value', render); // allow ng-value to set the value of the checkbox

        $el.on('click', clickHandler);
        $scope.$on('$destroy', function () {
          rgCtrl.remove(render);
        });
      }
      function clickHandler(ev) {
        if ($el[0].hasAttribute('disabled')) {
          return;
        }
        $scope.$apply(function () {
          rgCtrl.setViewValue($attr.value, ev && ev.type);
        });
        $el.trigger("change");
      }
      function render() {
        var checked = rgCtrl.getViewValue() === $attr.value;
        if (checked === lastChecked) {
          return;
        }
        lastChecked = checked;
        if (checked) {
          $el.addClass(CHECKED_CSS);
        } else {
          $el.removeClass(CHECKED_CSS);
        }
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-radio-button.js
// module id = 2977
// module chunks = 13